export const EventConstants = {
  BACKGROUND_LOADED: 'Background is successfully loaded',
  VARIANT_LOADED: 'Variant is loaded',
};
